import React from 'react';
import '../WebflowCss/ark-payment.webflow.css';
import Card from '../assets/images/credit-card-duotone.svg';
import Cash from '../assets/images/money-bill-duotone.svg';
import Cart from '../assets/images/shopping-cart-duotone.svg';

export const InfoSection = () => {
  return (
    <div className="info-section">
      <div className="presenter-container vertical">
        <div className="info-headline">How Ark helps your Business</div>
        <div className="item-container-row">
          <div className="row-item">
            <div className="icon-circle">
              <img src={Card} loading="lazy" alt="" className="row-item-image" />
            </div>
            <div className="text-block-40">
              Accept
              <br />
              all cards
            </div>
            <div className="text-block-25">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
              sed diam voluptua. At vero eos et accusam et jus
            </div>
          </div>
          <div className="row-item">
            <div className="icon-circle">
              <img src={Cash} loading="lazy" alt="" className="row-item-image" />
            </div>
            <div className="text-block-40">
              Increase
              <br />
              Cashflow
            </div>
            <div className="text-block-25">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
              sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren
            </div>
          </div>
          <div className="row-item">
            <div className="icon-circle">
              <img src={Cart} loading="lazy" alt="" className="row-item-image" />
            </div>
            <div className="text-block-40">
              Happy
              <br />
              customers
            </div>
            <div className="text-block-25">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
              sed diam voluptua. At vero eos et accusam et just
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
